var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"navbar-tab",class:{ 'tab-focus': _vm.focus },attrs:{"to":{name: _vm.href}}},[_c('span',{staticClass:"tab-label"},[_vm._v(_vm._s(_vm.$t(("General." + _vm.label))))])])}
var staticRenderFns = []

export { render, staticRenderFns }